const TemplateTriviaQuestions = ( number, id, question, answer1, answer2, answer3, answer4, cls, ans, correct, respuesta_correcta )=>{
    const createDiv = document.createElement('div');
    createDiv.classList.add('block');
    createDiv.classList.add(`${cls}`);
    const template = `
        <div class="question">
            <h6>${ number + 1 }.</h6>
            <p>${ question }</p>
        </div>
        <div class="answers">
            <label class="item answer-sound 
                ${ans && respuesta_correcta == "respuesta1" && correct && 'success'} 
                ${ans && respuesta_correcta == "respuesta1" && 'correct'} 
                ${ans && ans == "respuesta1" && !correct && "error"}
            ">
                <input type="radio" name="${id}" id="respuesta1" value="${ answer1 }">
                <span for="respuesta1"><b>A</b> ${ answer1 }</span>
            </label>
            <label class="item answer-sound 
                ${ans && respuesta_correcta == "respuesta2" && correct && 'success'} 
                ${ans && respuesta_correcta == "respuesta2" && 'correct'} 
                ${ans && ans == "respuesta2" && !correct && "error"}
            ">
                <input type="radio" name="${id}" id="respuesta2" value="${ answer2 }">
                <span for="respuesta2"><b>B</b> ${ answer2 }</span>
            </label>
            <label class="item answer-sound 
                ${ans && respuesta_correcta == "respuesta3" && correct && 'success'} 
                ${ans && respuesta_correcta == "respuesta3" && 'correct'} 
                ${ans && ans == "respuesta3" && !correct && "error"}
            ">
                <input type="radio" name="${id}" id="respuesta3" value="${ answer3 }">
                <span for="respuesta3"><b>C</b> ${ answer3 }</span>
            </label>
            <label class="item answer-sound 
                ${ans && respuesta_correcta == "respuesta4" && correct && 'success'} 
                ${ans && respuesta_correcta == "respuesta4" && 'correct'} 
                ${ans && ans == "respuesta4" && !correct && "error"}
            ">
                <input type="radio" name="${id}" id="respuesta4" value="${ answer4 }">
                <span for="respuesta4"><b>D</b> ${ answer4 }</span>
            </label>
        </div>
        <div class="btn-block">
            <a class="btn btn--uppercase btn-sound disabled-trivia" data-question="${ id }">Siguiente</a>
            <a class="btn-false btn-false--tertiary btn-false--uppercase" id="cancel-trivia">Cancelar Trivia</a>
        </div>
    `;

    createDiv.innerHTML += template;

    return createDiv;

}

const TemplateRanking = (cls, position, name, correctAnswers, time)=>{
    const createDiv = document.createElement('div');
    createDiv.classList.add('item-body');

    const template = `
        <h6 class="bold uppercase white ${cls}"><span>Posición:</span> ${position}</h6>
        <p class="small"><span>Usuario:</span> ${name}</p>
        <h6 class="bold uppercase white"><span>Respuestas correctas:</span> ${correctAnswers}</h6>
        <h6 class="bold uppercase white"><span>Tiempo:</span> ${time}</h6>
    `;

    createDiv.innerHTML += template;

    return createDiv;
}

const TemplateMyPosition = (position, username, lastname, total, questions, time)=>{
    const createDiv = document.createElement('div');
    createDiv.classList.add('item');

    const template = `
        <h6 class="white bold">${position}</h6>
        <p class="small">${username + " " + lastname}</p>
        <p class="bold">${total}/${questions}</p>
        <p class="bold">${time}</p>
    `;

    createDiv.innerHTML += template;

    return createDiv;
}


export { TemplateTriviaQuestions, TemplateRanking, TemplateMyPosition }